export default __webpack_public_path__ + "static/media/toggle-support-b.eb9561b2.svg";